<div class="filters-container" [class.di-none]="!expandFilters" fxLayout="row" fxLayoutAlign="flex-start center">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px" class="toolbar-table-filters">
    <div fxLayout="row" fxLayoutAlign="flex-start center">
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.searchTable)">
        <mat-form-field appearance="outline" class="regular no-padding-bottom">
          <mat-label>
            <mat-icon>search</mat-icon>
            {{ (storeId === TrainingsFilters.orgaMemberFilters ? 'organization.members.filter' : 'organization.trainings.filter') | translate }}
          </mat-label>
          <input
            matInput
            [(ngModel)]="filteredTable"
            [ngModelOptions]="{ standalone: true }"
            type="text"
            [placeholder]="'organization.members.filter' | translate"
            (change)="onMemberNameChange()"
          />
        </mat-form-field>
      </div>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.members)"
        #memberFilter
        [showDetails]="!filters?.includes(ToolbarFiltersTypes.memberIdentifiers)"
        [className]="Member"
        [initialIds]="storedTrainingsFilters?.filter?.member_ids"
        [placeholder]="'filters.name' | translate"
        [placeholderLabel]="'filters.name' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterMembers($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.memberIdentifiers)"
        #memberIdentifierFilter
        [className]="MemberIdentifier"
        [initialIds]="storedTrainingsFilters?.filter?.member_identifiers"
        [placeholder]="(enableLoginUsername ? 'filters.identifier' : 'filters.email') | translate"
        [placeholderLabel]="(enableLoginUsername ? 'filters.identifier' : 'filters.email') | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterMemberIdentifiers($event)"
      ></app-multi-select-server-side-search>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.type)">
        <mat-form-field appearance="outline" class="no-padding-bottom mb-0 regular">
          <mat-label>{{ 'reusable.trainingType' | translate }}</mat-label>
          <mat-select [(ngModel)]="trainingType" (selectionChange)="onTrainingType($event)">
            <mat-option [value]="null">-</mat-option>
            <mat-option value="Course" style="text-transform: capitalize;">{{ 'sections.courses' | translate }}</mat-option>
            <mat-option value="IltCourse" style="text-transform: capitalize;">{{ 'sections.iltCourses' | translate }}</mat-option>
            <mat-option value="LearningPath" style="text-transform: capitalize;">{{ 'sections.learningPaths' | translate }}</mat-option>
            <mat-option *ngIf="storeId === TrainingsFilters.publishingApprovalFilters" value="Schedule" style="text-transform: capitalize;">{{ 'sections.trainingSchedules' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.courses)"
        #courseFilter
        [className]="Course"
        [initialIds]="storedTrainingsFilters?.filter?.course_ids"
        [placeholder]="'sections.courses' | translate"
        [placeholderLabel]="'filters.coursesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onCourseFilter($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-local-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.coursesLocal)"
        #courseLocalFilter
        [className]="Course"
        [initialIds]="storedTrainingsFilters?.filter?.course_ids"
        [resources]="coursesLocalResources"
        [placeholder]="'sections.courses' | translate"
        [placeholderLabel]="'filters.coursesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        (selectResources)="doLocalFilterCourses($event)"
      ></app-multi-select-local-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.trainings)"
        #iltCourseFilter
        [className]="ILTCourse"
        [initialIds]="storedTrainingsFilters?.filter?.ilt_course_ids"
        [placeholder]="'sections.iltCourses' | translate"
        [placeholderLabel]="'filters.coursesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onIltFilter($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-local-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.trainingsLocal)"
        #iltCourseLocalFilter
        [className]="ILTCourse"
        [initialIds]="storedTrainingsFilters?.filter?.ilt_course_ids"
        [resources]="iLTCoursesLocalResources"
        [placeholder]="'sections.iltCourses' | translate"
        [placeholderLabel]="'filters.iltCoursesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        (selectResources)="onIltLocalFilter($event)"
      ></app-multi-select-local-search>
      <app-multi-select-local-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.trainingsEvents) && iltCourseLocalFilter?.multiSelect?.value?.length"
        #eventsFilter
        [className]="ILTCourseEvent"
        [resources]="iltEventsResources"
        [placeholder]="'sections.events' | translate"
        [initialIds]="storedTrainingsFilters?.filter?.ilt_course_event_ids"
        [placeholderLabel]="'filters.eventsPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        (selectResources)="doFilterEvents($event)"
      ></app-multi-select-local-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.learningPaths)"
        #learningPathFilter
        [className]="LearningPath"
        [initialIds]="storedTrainingsFilters?.filter?.learning_path_ids"
        [placeholder]="'sections.learningPaths' | translate"
        [placeholderLabel]="'filters.learningPathsPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onLPFilter($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-local-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.learningPathsLocal)"
        #learningPathLocalFilter
        [className]="LearningPath"
        [initialIds]="storedTrainingsFilters?.filter?.learning_path_ids"
        [resources]="learningPathLocalResources"
        [placeholder]="'sections.learningPaths' | translate"
        [placeholderLabel]="'filters.learningPathsPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        (selectResources)="doFilterLPLocal($event)"
      ></app-multi-select-local-search>
      <app-multi-select-local-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.categories)"
        #categoryLocalFilter
        [className]="CourseCategory"
        [resources]="allCategories"
        [initialIds]="storedTrainingsFilters?.filter?.course_category_ids"
        [placeholder]="'sections.categories' | translate"
        [placeholderLabel]="'filters.categoriesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        (selectResources)="doFilterCategories($event)"
      ></app-multi-select-local-search>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.trainingTags)" class="training-tags-filter-wrapper" [class.has-chips]="selectedTagChips.length" [class.expanded]="tagFilterExpanded" [style.--tag-filter-width]="tagFilterWidth + 'px'">
        <app-multi-select-server-side-search
          #trainingTagFilter
          [initialIds]="storedTrainingsFilters?.filter?.tag_ids"
          [className]="TrainingTag"
          [placeholder]="'settings.trainingTags.filterLabel' | translate"
          [placeholderLabel]="'settings.trainingTags.filterLabel' | translate"
          [noEntriesFoundLabel]="'filters.noDataFound' | translate"
          [preventInitialEmitEvent]="true"
          [showColorDot]="true"
          (selectEvent)="onTrainingTagFilter($event)"
          (initialValueLoaded)="onTagInitialValueLoaded($event)"
        ></app-multi-select-server-side-search>
        <div class="tag-chips-overlay" *ngIf="selectedTagChips.length" (click)="trainingTagFilter.multiSelect.open()">
          <span class="tag-chip" *ngFor="let tag of visibleTagChips">
            <span class="tag-chip-dot" [style.background-color]="tag.color"></span>
            <span class="tag-chip-name">{{ tag.name }}</span>
            <span class="tag-chip-remove" (click)="removeTagChip(tag, $event)">&#x2715;</span>
          </span>
          <span *ngIf="selectedTagChips.length > visibleTagChips.length" class="tag-overflow-chip">
            +{{ selectedTagChips.length - visibleTagChips.length }}
          </span>
        </div>
      </div>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.courseActivities)"
        #courseActivityFilter
        [className]="CourseActivity"
        [initialIds]="storedTrainingsFilters?.filter?.course_activity_ids"
        [placeholder]="'filters.tasksPlaceholder' | translate"
        [placeholderLabel]="'filters.tasksPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [initialFilters]="{ own_task_activity: true }"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterCourseActivities($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.trainingSchedules)"
        #scheduleFilter
        [className]="TrainingSchedule"
        [initialIds]="storedTrainingsFilters?.filter?.schedule_ids"
        [placeholder]="'sections.trainingSchedules' | translate"
        [placeholderLabel]="'filters.trainingSchedulesPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterTrainingSchedules($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.cohorts)"
        #scheduleCohortsFilter
        [className]="TrainingScheduleCohort"
        [initialIds]="storedTrainingsFilters?.filter?.cohort_ids"
        [placeholder]="'sections.trainingScheduleCohorts' | translate"
        [placeholderLabel]="'filters.trainingScheduleCohortsPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [initialFilters]="{ schedule_id: scheduleCohortFilterId }"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterTrainingScheduleCohorts($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.editors)"
        #editorFilter
        [multiple]="false"
        [showDetails]="!filters?.includes(ToolbarFiltersTypes.editors)"
        [className]="Member"
        [initialIds]="storedTrainingsFilters?.filter?.editor_ids"
        [initialFilters]="getEditorInitialFilters()"
        [placeholder]="'filters.editors' | translate"
        [placeholderLabel]="'filters.editors' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onFilterEditors($event)"
      ></app-multi-select-server-side-search>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.courseStatus)">
        <mat-form-field appearance="outline" class="no-padding-bottom regular">
          <mat-label>{{ 'courses.courseStatus' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedCourseStatus" (selectionChange)="onCourseStatusChanged($event)" [multiple]="true">
            <mat-option [value]="CourseProgressStatus.new" style="text-transform: capitalize;">{{ 'common.new' | translate }}</mat-option>
            <mat-option [value]="CourseProgressStatus.running" style="text-transform: capitalize;">{{ 'courses.status.running' | translate }}</mat-option>
            <mat-option [value]="CourseProgressStatus.finished" style="text-transform: capitalize;">{{ 'courses.status.finished' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.trainingStatus)">
        <mat-form-field appearance="outline" class="no-padding-bottom regular">
          <mat-label>{{ 'iltCourses.status.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedTrainingStatus" (selectionChange)="onTrainingStatusChanged($event)" [multiple]="true">
            <mat-option [value]="ILTCourseStatus.assigned" style="text-transform: capitalize;">{{ 'iltCourses.status.assigned' | translate }}</mat-option>
            <mat-option [value]="ILTCourseStatus.subscribed" style="text-transform: capitalize;">{{ 'iltCourses.status.subscribed' | translate }}</mat-option>
            <mat-option [value]="ILTCourseStatus.completed" style="text-transform: capitalize;">{{ 'courses.status.finished' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.languages)">
        <mat-form-field appearance="outline" class="no-padding-bottom mb-0 small">
          <mat-label>{{ 'filters.language' | translate }}</mat-label>
          <mat-select [multiple]="true" [(ngModel)]="filterLanguage" (selectionChange)="onFilterLanguage($event)">
            <mat-option *ngFor="let language of languages; let i = index" [value]="language">
              <app-elearnio-language-span [countryCode]="language"></app-elearnio-language-span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.trainingAvailability)">
        <mat-form-field appearance="outline" class="no-padding-bottom small">
          <mat-label>{{ 'trainings.status.availability.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedTrainingAvailabilityStatus" (selectionChange)="onTrainingAvailabilityStatusChanged($event)" [multiple]="true" panelClass="app-toolbar-filters-training-status-panel">
            <mat-option [value]="TrainingAvailability.DRAFT" style="text-transform: capitalize;">{{ 'trainings.status.availability.draft' | translate }}</mat-option>
            <mat-option [value]="TrainingAvailability.ACTIVE" style="text-transform: capitalize;">{{ 'trainings.status.availability.active' | translate }}</mat-option>
            <mat-option [value]="TrainingAvailability.ARCHIVED" style="text-transform: capitalize;">{{ 'trainings.status.availability.archived' | translate }}</mat-option>
            <mat-option [value]="TrainingAvailability.PENDING_PUBLISHING_APPROVAL" style="text-transform: capitalize;">{{ 'settings.publishingApproval.status' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.emailTemplates)"
        #customEmailNameSearch
        [initialIds]="storedTrainingsFilters?.filter?.email_ids"
        [className]="CustomEmail"
        [initialFilters]="{ email_language: selectedLanguage}"
        [placeholder]="'settings.customEmailList.templateName' | translate"
        [placeholderLabel]="'settings.customEmailList.templateName' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onCustomEmailFilter($event)"
      ></app-multi-select-server-side-search>
      <app-multi-select-server-side-search
        *ngIf="filters?.includes(ToolbarFiltersTypes.groups)"
        #groupFilter
        [className]="Group"
        [initialIds]="storedTrainingsFilters?.filter?.group_ids"
        [placeholder]="'sections.groups' | translate"
        [placeholderLabel]="'filters.groupsPlaceholder' | translate"
        [noEntriesFoundLabel]="'filters.noDataFound' | translate"
        [preventInitialEmitEvent]="true"
        (selectEvent)="onGroupFilter($event)"
      ></app-multi-select-server-side-search>
      <mat-slide-toggle fxLayout="row"
        *ngIf="filters?.includes(ToolbarFiltersTypes.author) && !isAuthorOrLearner"
        [(ngModel)]="authorChecked" 
        (change)="onAuthorToggleChange($event)"
        labelPosition="after"
      >
        {{ 'courses.admin-list.my-courses' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle fxLayout="row"
        *ngIf="filters?.includes(ToolbarFiltersTypes.mandatory)"
        [(ngModel)]="mandatory" 
        (change)="onMandatoryToggleChange($event)"
        labelPosition="after"
      >
        {{ 'filters.mandatory' | translate }}
      </mat-slide-toggle>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.emailTemplatesType)">
        <mat-form-field 
        appearance="outline" 
        class="mat-form-field-filter regular"
        >
          <mat-label>{{ 'settings.customEmailList.templateType' | translate }}</mat-label>
          <mat-select
            #allTypes
            [ngModel]="filterCustomEmailsType"
            [multiple]="true"
            [compareWith]="compareEmailTypes"
            (selectionChange)="onEmailTypeFilter($event)"
          >
            <mat-option *ngFor="let type of customEmailTypes | keyvalue; let i = index" [value]="type">
                {{type.value | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.hireDate)" class="hire-date-filter">
        <mat-form-field appearance="outline" class="no-padding-bottom regular">
          <mat-label>{{ 'settings.personal.hireDate' | translate }}</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [value]="startDate" [placeholder]="'common.startDate' | translate" (dateChange)="onHireStartDateFilter($event)">
            <input matEndDate [value]="endDate" [placeholder]="'common.endDate' | translate" (dateChange)="onHireEndDateFilter($event)">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.hrStatus)">
        <mat-form-field appearance="outline" class="no-padding-bottom regular">
          <mat-label>{{ 'reporting.header.hrStatusLabel' | translate }}</mat-label>
          <mat-select [(ngModel)]="hrStatusFilter" multiple (selectionChange)="onHrStatusFilter($event)">
            <mat-option *ngFor="let status of hrStatuses" [value]="status" style="text-transform: capitalize;">
              {{'talents.profile.hrStatuses.' + status | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.memberStatus)">
        <mat-form-field appearance="outline" class="no-padding-bottom regular">
          <mat-label>{{ 'reporting.header.userStatusLabel' | translate }}</mat-label>
          <mat-select [(ngModel)]="userStatusFilter" multiple (selectionChange)="onUserStatusFilter($event)">
            <mat-option *ngFor="let status of userStatuses" [value]="status" style="text-transform: capitalize;">
              {{'talents.profile.userStatuses.' + status | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.checkUserName) && enableLoginUsername" fxLayoutGap="12px" fxLayoutAlign="flex-start center">
        <mat-slide-toggle
          [checked]="checkUsersWithUsername"
          (change)="changeCheckUsersWithUsername($event)"
          labelPosition="after"
        >
          {{ 'reporting.header.checkUserWithUsername' | translate }}
        </mat-slide-toggle>
      </div>
      <div *ngIf="filters?.includes(ToolbarFiltersTypes.subunits)">
        <mat-slide-toggle 
          [(ngModel)]="checkedSubunits" 
          (change)="onToggleSubunits($event)" 
          labelPosition="after">
            {{ 'organization.members.subunits' | translate }}
          </mat-slide-toggle>
      </div>
      <div *ngIf="filters && mobileQuery.matches" fxLayout="row" fxLayoutAlign="flex-end">
        <button mat-stroked-button color="darkblue" class="no-border reset-filters-btn with-icon-margin" (click)="onResetFilters()">
          <mat-icon class="size-s">filter_list_off</mat-icon>
          <span>{{ 'common.reset' | translate }}</span>
        </button>
      </div>
    </div>
    <button *ngIf="filters && !mobileQuery.matches" mat-stroked-button color="darkblue" class="no-border reset-filters-btn with-icon-margin" (click)="onResetFilters()">
      <mat-icon class="size-s">filter_list_off</mat-icon>
      <span>{{ 'common.reset' | translate }}</span>
    </button>
  </div>
</div>